import Tags from '~/src/molecules/Tags/';
import tw from 'twin.macro';
import React from 'react';
import useSelectedPack from './useSelectedPack';

const Offers = ({ isB2B = false, showOffers = true, ...rest }) => {
  const { pricing = {} } = useSelectedPack();
  if (!showOffers) return <div {...rest}></div>;
  if (pricing?.discount?.d_avail === 'false' || !pricing?.discount?.d_text) return <div></div>;
  return (
    <div css={tw`absolute top-0 left-0`} {...rest}>
      <Tags variant={isB2B ? 'b2bOffer' : 'offer'}>
        <span className={'font-semibold lg:text-xs xl:text-sm leading-xxl xl:leading-md'} dangerouslySetInnerHTML={{ __html: pricing?.discount?.d_text }} />
      </Tags>
    </div>
  );
};

export default Offers;
